import { Course } from 'types/data'

export const getEpisodeListFromCourse = (course: Course) => {
  const { upcomingChapter, sortedSubchapters, sortedChapters } = course

  if (sortedSubchapters?.length) {
    return upcomingChapter
      ? [...sortedSubchapters, upcomingChapter]
      : sortedSubchapters
  }

  return upcomingChapter && sortedChapters
    ? [...sortedChapters, upcomingChapter]
    : sortedChapters
}
